export enum Widget {
    Login = 'LOGIN',
    SignUp = 'SIGNUP',
    ForgotPassword = 'FORGOTPASSWORD',
  }